// #384654
// 928D01 second button

export const token = {
  productCount: '#696969',
  cardTagText: '#4D4D4D',
  cardMutedText: '#6B6A5C',
  cardDivider: '#ECECEC',
  brand01: '#384654',
  black: '#2A1A1A',
  softShadowBlack: '#00000040',
  halfBlack: 'rgba(0, 0, 0, 0.4)',
  brand02: '#928D01',
  discountTagBg: '#C9DA00',
  white: '#ffffff',
  eMarket: '#8394A1',
  wholesale: '#2988BC',
  whiteSmoke: '#F5F5F5',
  grayBg: '#F7F7F7',
  mistBlue: '#cdd6da',
  almostWhite: '#FCFCFC',
  black2: '#000000',
  bgColorHover: '#384654',
  slickDotBgColor: '#C9C9C9',
  topPriceBgColor: '#D6353B',
  grey: '#838383',
  deepSlate: '#384656',
  navDark: '#384654',
  lightGrey: '#E9E9E9',
  silverGray: '#E0E0E0',
  mediumGray: '#D9D9D9',
  cloudGray: '#F1F4F7',
  neutralGray: '#8D8D8D',
  softSilverGray: '#A9ABAD',
  lightGrayishBlue: '#D1D1D8',
  softSlateBlue: '#38465433',
  containerBgColor: '#F8F8F8',
  borderBottom: '#E1E1E1',
  lightBorder: '#E8E8E8',
  lightGrayBorder: '#EEEEEE',
  darkRed: '#9D0909',
  red: '#D6353B',
  discountCrossRed: '#D6353B4D',
  removeProductRed: '#E14B4B',
  brightGrey: '#F4F4F4',
  mediumGrey: '#CBCBCB',
  softShadowGray: '#3846540D',
  stepArrowColor: '#292D32',
  menuBorderBottom: '#CCCCCC',
  backgroundOverlay: '#38465480',
  goldenYellow: '#DAC400',
  filterSelectBg: 'rgba(34, 197, 94, 1)',
  inputGrey: 'rgba(244, 244, 244);',
  veryLightGray: '#f2f2f2',
  cartWarningBackground: `rgba(131, 148, 161, 1)`,
  greyBackground: '#F5F5F5',
  backgroundColorFarmButton: '#6D757D',
  mainBgColor: `rgba(255, 255, 255, 1)`,
  lightborder: `rgba(245, 245, 245, 1)`,
  summaryBackground: `rgba(248, 248, 248, 1)`,
  boxShadowColor: `#00000026`,
  inputBitDarkerOverlay: `rgba(56, 70, 84, 0.05)`,
  paginationLink: '#475569',
  paginationActiveBg: '#384654',
  radioCheckGreen: ` #22c55e`,
  counterBrown: `#3C3C3C`,
  headerBottom: '#E5E7EB',
  loginBackgroundColor: '#f1f1f1',
  tagBorderColor: '#d6d6d6',
  optionTagBg: '#F7F5EE',
  tabDivider: '#DCDCDC',
  tabActiveBar: '#3F3F3F',
  lightboxOverlay: 'rgba(0, 0, 0, 0.85)',
  farmServiceTagBorderColor: '#F59E0B',
  manslauksZils: '#12589F',

  checkboxBorderColor: '#B0BABF',
  activeCheckboxBackground: '#22C55E',
  activeCheckboxBorder: '#16A34A',

  progressBarFill: '#F59E0B',

  warning: '#f29746',

  contentWidth: '1440px',
  mainFooterFontSize: '14px',

  boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2);',

  profileBoxShadow: '0 2px 8px rgba(0, 0, 0, 0.1);',
  profileFontFamily: 'Arial, sans-serif;',
  profileFontFamilySecondary: 'Albert Sans',
  profileBlack: '#333',
  profileName: '#666',
  profileColor: '#17183B',
  profileLineColor: '#d1d1d8',
  profileAddCompany: '#384654',
  profileMenuLine: '#eaeaea',
  profileTitle: '#384654',
  profileCount: '#696969',
  profileSubTitle: '#12141D',
  searchInputBgColor: '#F1F1F1',

  adressBlue: '#384654',
  adressGray: '#606b76',
  adressBoxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.075)',

  mainHeaderHeight: '40px',
  secondHeaderHeight: '105px',

  mainFooterHeight: '140px',

  //icons
  iconWidthESM: '6px',
  iconHeightESM: '6px',
  iconWidthSM: '14px',
  iconHeightSM: '14px',
  iconWidthLG: '70px',
  iconWidthMED: '24px',
  iconHeightMED: '24px',
  iconWidthCard: '33px',
  iconHeightCard: '33px',
  iconHeightFilter: '79px',
  iconWidthFilter: '79px',
  iconHeightAvarage: '19px',
  iconWidthAvarage: '19px',
  iconWidthHeader: '92px',
  iconHeihtHeader: '60px',
  iconWidthAny: '100%',
  iconHeihtAny: '100%',
  iconWidthMobileFooter: '414px',
  iconHeihtMobileFooter: '41px',
  iconHeihtFooter: '85px',
  iconWidthFooter: '880px',
  iconHeihtCartDrawerClose: '40px',
  iconWidthCartDrawerClose: '40px',

  // SeedToken
  borderRadius: 30,
  colorPrimary: '#928D01',
  fontSize: 16,
  darkGrayishBlue: '#4C4F54',
  grayishBlue: '#94A3B8',
  vividBlue: '#2563EB',
  dustyBlue: '#64748B',

  // MapToken
  colorBgBlur: 'transparent',
  colorBgContainer: 'transparent',
  colorBorder: '#DADADA',
  colorBorderSecondary: '#f0f0f0',
  colorText: '#2A1A1A',
  colorSplit: 'rgba(5, 5, 5, 0.06)',
  controlOutline: 'rgba(5, 145, 255, 0.1)',
  fontText: "'Manrope', sans-serif",
  fontFamily: "'Manrope', sans-serif",

  buttonContainer: '0 -2px 5px rgba(0, 0, 0, 0.1)',
  loginCustomButtonBackground: '#ECECEC',
  errorBadge: '#ff4d4f',
};

export const adminToken = {
  cardTagText: '#4D4D4D',
  cardMutedText: '#6B6A5C',
  cardDivider: '#ECECEC',
  brand01: '#384654',
  brand02: '#928D01',
  white: '#ffffff',
  blue: 'blue',
  statusBlue: '#5578eb',
  statusYellow: '#ffb822',
  statusRose: '#fd397a',
  fontText: "'Manrope', sans-serif",
  black: '#000000',
  darkGrayishBlue: '#4C4F54',
  contentWidth: '1437px',
  border: '#DADADA',
  filterBackground: '#F5F6F7',
  suffixBackground: '#f7f8fa',
  suffixBorder: '#495057',
  siderColor: '#C4C7CB',
  stepInactiveColor: '#888E98',
  stepArrowColor: '#292D32',
  actionCollor: '#93a2dd',
  modalHorizontalLine: '#ebedf2',
  checked: '#0abb87',
  minus: '#fd397a',
  underTextColor: '#7B7B7B',
  red: 'red',
  borderTable: '#E6E6E6',
  textColor: '#4B5563',
  warning: '#ffcf6e',
  halfBlack: 'rgba(0, 0, 0, 0.4)',
  borderBottom: '#E5E5E5',
  errorBadge: '#ff4d4f',
  warningBannerBg: '#fff4e5',
  warningBannerBorder: '#f29746',
  warningBannerText: '#9a4b00',
  readOnlyBg: '#F1F1F1',
  grayTextColor: '#929292',
  dimmedTextColor: '#838383',
  wholesale: '#2988BC',
  manslauksZils: '#12589F',
  graytext: '#8B8B8B',

  progressBar: '#DFDFDF',
  progressBarFill: '#F59E0B',
  softSilverGray: '#A9ABAD',

  qualityMarkSuccess: '#52c41a',
  qualityMarkDisabled: '#8c8c8c',

  sortArrowActive: '#292d32',
  sortArrowInActive: '#292d3266',

  inactiveColor: '#7C7C7C',
  tableSecondRowColor: '#F9FAFB',
  borderCheckbox: '#D5DAE1',
  activeCheckboxBackground: '#22C55E',
  activeCheckboxBorder: '#16A34A',
  disableCheckboxBackground: '#D5DAE1',
  disableCheckboxBorder: '#8896AB',
  inputAddonBg: '#EDEDED',
  tagCloseColor: '#292D32',
  backgroundInput: '#F7F7F7',
  borderInput: '#D5D5D5',
  imageBorder: '#C3C3C3',
  descriptionText: '#898989',

  statusUnpublished: '#6c757d',
  statusPublished: '#0d6efd',
  statusHasOffers: '#6f42c1',
  statusClosed: '#495057',
  statusPartiallyCompleted: '#13ed88',
  statusCompleted: '#198754',
  statusCancelled: '#fd7e14',
  statusUnsuccessful: '#dc3545',
  badgeBackground: '#6F7379',

  contractTextColor: '#646c9a',
  contractTextTitleColor: '#48465b',
  outlineColor: '#C4C4C4',
  blueColor: '#5867dd',
  silverGray: '#E0E0E0',
  cardBorder: '#AFAFAF',
  cardFirstElement: '#888E98',
  cardSecondElement: '#4C4F54',

  categoryBorder: '#ccc',
  categoryVatBackground: 'rgb(145, 154, 173)',
  categoryContentBackground: '#fafafa',
  categoryHandlerBackground: '#d6d6d6',
  categoryActionBackground: '#5d78ff',

  addProductUnderline: 'rgba(196, 196, 196, 1)',

  // SeedToken
  borderRadius: 0,
  colorPrimary: '#4C4F54',
  fontSize: 16,
  fontFamily: "'Manrope', sans-serif",
  colorLink: '#4C4F54',

  // MapToken
  colorBorder: '#d9d9d9',
  colorBorderSecondary: '#f0f0f0',
  colorText: '#4C4F54',
  colorSplit: 'rgba(5, 5, 5, 0.06)',
  controlOutline: 'rgba(5, 145, 255, 0.1)',

  colorPadding: '#6B7280',
  colorButtonText: '#065F46',
  colorStatusChangeLine: '#d7d7d7',

  filterBorder: '#d7d7d7',

  colorPaginationActiveBorder: '#E5E7EB',
  userCompanyBoxShadow: '#0000001a',

  iconGreen: '#0abb87',
  iconRed: '#fd397a',
  iconBlue: '#5d78ff',
  adminIconSize: 22,

  checkboxInner: '#22c55e',

  mobileMenuDrawerBackGround: '#384655',

  listingNotifications: '#0056B3',
  offerNotifications: '#FF9800',
  dealsNotifications: '#4CAF50',
  orderNotifications: '#9C27B0',
  messageNotifications: '#878FFF',
  reservationNotifications: '#D6353B',
  transactionNotifications: '#22C55E',
  // RatingTokens
  ratingStarColor: '#fAAD14',
  startRatingBase: `rgba(131, 148, 161, 1)`,

  // Transaction Type Tags
  eMarketTransactionTag: '#39793B',
  orderTransactionTag: '#1B581C',
  wholesaleTransactionTag: '#4CAF50',
  motherOrderTransactionTag: '#3D78A6',
  motherPurchaseTransactionTag: '#6ABDFF',
  motherReservationTransactionTag: '#137ED3',
  motherDynamicPurchaseTransactionTag: '#01508F',

  motherChildStatusDone: '#4CAF50',
  motherChildStatusSent: '#1B581C',
  motherChildStatusConfirmed: '#39793B',
  motherChildStatusPartiallySent: '#6ABDFF',
  motherChildStatusCanceled: '#137ED3',
  motherChildStatusNew: '#01508F',
  motherChildStatusPendingSend: '#3D78A6',

  // Payment Status Tags
  paymentStatusPaid: '#4C4F54',
  paymentStatusUnpaid: '#FFA500',

  // Mother Transaction Row
  motherTransactionBg: '#F0F0F0',
  expandedBorderBlue: '#086BBA',
  expandedBorderGray: '#D9D9D9',

  // Chat colors
  chatHeaderDateColor: '#8F8F8F',
  chatBgLight: '#FFFFFF',
  chatSenderLabelColor: '#9A9A9AD9',
  chatBubbleRecipient: '#F4F4F7',
  chatBubbleRecipientBorder: '#E8E8E8',
  chatBubbleOwn: '#F4F4F7',
  chatInputBorder: '#D9D9D9',
  chatScrollButtonBg: '#FFFFFF',
  chatScrollButtonBorder: '#D9D9D9',
  chatScrollButtonShadow: 'rgba(0, 0, 0, 0.15)',
  chatScrollButtonHover: '#F5F5F5',
  chatCheckmarkGreen: '#27AE60',
  chatDayDividerColor: '#00000073',
  chatInputBackground: '#FAFAFA',
};

export const wholeSaleToken = {
  productCount: '#696969',
  cardTagText: '#4D4D4D',
  cardMutedText: '#6B6A5C',
  cardDivider: '#ECECEC',
  brand01: '#2988BC',
  black: '#2A1A1A',
  softShadowBlack: '#00000040',
  halfBlack: 'rgba(0, 0, 0, 0.4)',
  brand02: '#928D01',
  discountTagBg: '#C9DA00',
  white: '#ffffff',
  eMarket: '#8394A1',
  wholesale: '#2988BC',
  whiteSmoke: '#F5F5F5',
  grayBg: '#F7F7F7',
  mistBlue: '#cdd6da',
  almostWhite: '#FCFCFC',
  black2: '#000000',
  bgColorHover: '#2988BC',
  slickDotBgColor: '#C9C9C9',
  topPriceBgColor: '#D6353B',
  grey: '#838383',
  deepSlate: '#384656',
  navDark: '#384654',
  lightGrey: '#E9E9E9',
  silverGray: '#E0E0E0',
  mediumGray: '#D9D9D9',
  cloudGray: '#F1F4F7',
  neutralGray: '#8D8D8D',
  softSilverGray: '#A9ABAD',
  lightGrayishBlue: '#D1D1D8',
  softSlateBlue: '#2988BC33',
  containerBgColor: '#F8F8F8',
  borderBottom: '#E1E1E1',
  lightBorder: '#E8E8E8',
  lightGrayBorder: '#EEEEEE',
  darkRed: '#9D0909',
  red: '#D6353B',
  discountCrossRed: '#D6353B4D',
  removeProductRed: '#E14B4B',
  brightGrey: '#F4F4F4',
  mediumGrey: '#CBCBCB',
  softShadowGray: '#2988BC0D',
  stepArrowColor: '#292D32',
  menuBorderBottom: '#CCCCCC',
  backgroundOverlay: '#2988BC80',
  goldenYellow: '#DAC400',
  filterSelectBg: 'rgba(34, 197, 94, 1)',
  inputGrey: 'rgba(244, 244, 244);',
  veryLightGray: '#f2f2f2',
  cartWarningBackground: `rgba(131, 148, 161, 1)`,
  greyBackground: '#F5F5F5',
  backgroundColorFarmButton: '#6D757D',
  mainBgColor: `rgba(255, 255, 255, 1)`,
  lightborder: `rgba(245, 245, 245, 1)`,
  summaryBackground: `rgba(248, 248, 248, 1)`,
  boxShadowColor: `#00000026`,
  inputBitDarkerOverlay: `rgba(56, 70, 84, 0.05)`,
  paginationLink: '#475569',
  paginationActiveBg: '#384654',
  radioCheckGreen: ` #22c55e`,
  counterBrown: `#3C3C3C`,
  headerBottom: '#E5E7EB',
  loginBackgroundColor: '#f1f1f1',
  borderInput: '#D5D5D5',
  manslauksZils: '#12589F',
  searchInputBgColor: '#F1F1F1',
  tagBorderColor: '#d6d6d6',
  optionTagBg: '#F7F5EE',
  tabDivider: '#DCDCDC',
  tabActiveBar: '#3F3F3F',
  lightboxOverlay: 'rgba(0, 0, 0, 0.85)',

  checkboxBorderColor: '#B0BABF',
  activeCheckboxBackground: '#22C55E',
  activeCheckboxBorder: '#16A34A',

  warning: '#f29746',

  contentWidth: '1440px',
  mainFooterFontSize: '14px',

  boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2);',

  profileBoxShadow: '0 2px 8px rgba(0, 0, 0, 0.1);',
  profileFontFamily: 'Arial, sans-serif;',
  profileFontFamilySecondary: 'Albert Sans',
  profileBlack: '#333',
  profileName: '#666',
  profileColor: '#17183B',
  profileLineColor: '#d1d1d8',
  profileAddCompany: '#2988BC',
  profileMenuLine: '#eaeaea',
  profileTitle: '#2988BC',
  profileCount: '#696969',
  profileSubTitle: '#12141D',

  adressBlue: '#2988BC',
  adressGray: '#606b76',
  adressBoxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.075)',

  mainHeaderHeight: '81px',
  secondHeaderHeight: '77px',

  mainFooterHeight: '140px',

  //icons
  iconWidthSM: '14px',
  iconHeightSM: '14px',
  iconWidthLG: '70px',
  iconWidthMED: '24px',
  iconHeightMED: '24px',
  iconWidthCard: '33px',
  iconHeightCard: '33px',
  iconHeightFilter: '79px',
  iconWidthFilter: '79px',
  iconHeightAvarage: '19px',
  iconWidthAvarage: '19px',
  iconWidthHeader: '92px',
  iconHeihtHeader: '60px',
  iconWidthAny: '100%',
  iconHeihtAny: '100%',
  iconWidthMobileFooter: '414px',
  iconHeihtMobileFooter: '41px',
  iconHeihtFooter: '85px',
  iconWidthFooter: '880px',
  iconHeihtCartDrawerClose: '40px',
  iconWidthCartDrawerClose: '40px',

  // SeedToken
  borderRadius: 30,
  colorPrimary: '#928D01',
  fontSize: 16,
  darkGrayishBlue: '#4C4F54',
  grayishBlue: '#94A3B8',
  vividBlue: '#2563EB',
  dustyBlue: '#64748B',

  // MapToken
  colorBgBlur: 'transparent',
  colorBgContainer: 'transparent',
  colorBorder: '#DADADA',
  colorBorderSecondary: '#f0f0f0',
  colorText: '#2A1A1A',
  colorTextFaintGray: '#919191',
  colorSplit: 'rgba(5, 5, 5, 0.06)',
  controlOutline: 'rgba(5, 145, 255, 0.1)',
  fontText: "'Manrope', sans-serif",
  fontFamily: "'Manrope', sans-serif",

  buttonContainer: '0 -2px 5px rgba(0, 0, 0, 0.1)',

  statusPublicUnpublished: '#6c757d',
  statusPublicPublished: '#F59E0B',
  statusPublicClosed: '#495057',
  statusPublicCompleted: '#198754',
  statusPublicCancelled: '#fd7e14',
  statusPublicUnsuccessful: '#dc3545',

  transactionPurchase: '#2988BC',
  transactionReservation: '#40DBA7',
  transactionDynamicPurchase: '#E79B25',
};
